import { default as i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import translationDE from "./localizations/de/translation.json";
import translationES from "./localizations/es/translation.json";
import translationEN from "./localizations/en/translation.json";
import translationJA from "./localizations/ja/translation.json";
import translationIT from "./localizations/it/translation.json";
import translationFR from "./localizations/fr/translation.json";
import translationPL from "./localizations/pl/translation.json";

export const availableApiLanguages = [
  { languageCode: "en", description: "English" },
  { languageCode: "de", description: "Deutsch" },
  { languageCode: "ja", description: "ジャパニーズ" },
  { languageCode: "es", description: "Español" },
  { languageCode: "it", description: "Italiano" },
  { languageCode: "fr", description: "Français" },
  { languageCode: "pl", description: "Polski" },
];

export const isKeyInTranslation = (key: string) => {
  return key in resources.en.translation;
};

export const STORED_LANG_KEY = "kemaro-stored-lang";
const getStoredOrDefaultLanguage = () => {
  const storedLanguageCode = localStorage.getItem(STORED_LANG_KEY);
  return availableApiLanguages.find((l) => l.languageCode === storedLanguageCode) ?? availableApiLanguages[0];
};

export const getCurrentLanguage = () => {
  const language = availableApiLanguages.find((lang) => lang.languageCode === i18n.language);
  return language ?? getStoredOrDefaultLanguage();
};

export const getLocalizationOrNull = (translationKey: string) => {
  if (i18n.t(translationKey) === translationKey) {
    return null;
  }
  return i18n.t(translationKey);
};

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  ja: {
    translation: translationJA,
  },
  es: {
    translation: translationES,
  },
  it: {
    translation: translationIT,
  },
  fr: {
    translation: translationFR,
  },
  pl: {
    translation: translationPL,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getCurrentLanguage().languageCode,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
